import React from 'react';

const BenefitDescription = ({ children }: { children: React.ReactNode }) => (
  <div className="mt-12 mb-8 min-h-[160px] w-full max-w-[640px] text-center font-['Work_Sans'] text-[16px] leading-[20px] font-normal tracking-[0%] text-black transition-all duration-500 ease-in-out max-sm:min-h-[180px] max-sm:text-[17px] max-sm:leading-[23px]">
    {children}
  </div>
);

export default BenefitDescription;
